import { useAxios, useSubjectId } from '@healthblocks-io/core'
import useSWR from 'swr'

import type { PatientViewDocument } from '../types/patient-documents.types'

export function usePatientDocumentById(id?: string) {
  const hbAxios = useAxios()
  const subjectId = useSubjectId()

  return useSWR(
    subjectId && id ? `/views/patient/documents/${id}?subjectId=${subjectId}` : null,
    async () => {
      const document = await hbAxios.get<PatientViewDocument>(`/views/patient/documents/${id}`, {
        params: {
          subjectId: subjectId?.toString() ?? '',
          include: 'detail',
        },
      })

      return document.data ?? ({} as PatientViewDocument)
    },
    { shouldRetryOnError: false },
  )
}
